/**
 * @generated SignedSource<<7a08fcd8f9b3e01b7d908976e9bc9bf6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type SchoolTypeEnum = "elementary_school" | "high_school" | "middle_school" | "%future added value";
export type TaskProblemTypeEnum = "copy" | "exam" | "private" | "problem_generator" | "pure" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type TaskHintFeedbackSaveDialog_task$data = {
  readonly hint: {
    readonly id: string;
    readonly text: string | null;
  } | null;
  readonly id: string;
  readonly problem: {
    readonly id: string;
    readonly problem: string | null;
    readonly problemType: TaskProblemTypeEnum;
    readonly solution: string | null;
  } | null;
  readonly problemSolveInfo: {
    readonly specialAnswers: ReadonlyArray<{
      readonly answer: string | null;
      readonly percentage: number | null;
      readonly rank: number;
    }>;
    readonly " $fragmentSpreads": FragmentRefs<"TaskProblemSolveInfoDescriptionList_taskProblemSolveInfo">;
  } | null;
  readonly publishedUnitDs: ReadonlyArray<{
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"UnitDItem_unitD">;
  }>;
  readonly sequence: number;
  readonly submitFeedback: {
    readonly general: string | null;
    readonly id: string;
    readonly special: string | null;
    readonly specialAnswer: string | null;
  } | null;
  readonly title: string;
  readonly unit: {
    readonly schoolType: SchoolTypeEnum;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"TaskDescriptionList_task">;
  readonly " $fragmentType": "TaskHintFeedbackSaveDialog_task";
};
export type TaskHintFeedbackSaveDialog_task$key = {
  readonly " $data"?: TaskHintFeedbackSaveDialog_task$data;
  readonly " $fragmentSpreads": FragmentRefs<"TaskHintFeedbackSaveDialog_task">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "filters"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "TaskHintFeedbackSaveDialog_task",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sequence",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TaskProblem",
      "kind": "LinkedField",
      "name": "problem",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "problemType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "problem",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "solution",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Unit",
      "kind": "LinkedField",
      "name": "unit",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "schoolType",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TaskHint",
      "kind": "LinkedField",
      "name": "hint",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "text",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TaskSubmitFeedback",
      "kind": "LinkedField",
      "name": "submitFeedback",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "specialAnswer",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "special",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "general",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TaskDescriptionList_task"
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "filters",
          "variableName": "filters"
        },
        {
          "kind": "Literal",
          "name": "order",
          "value": {
            "order": "DESC"
          }
        }
      ],
      "concreteType": "UnitD",
      "kind": "LinkedField",
      "name": "publishedUnitDs",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "UnitDItem_unitD"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TaskProblemSolveInfo",
      "kind": "LinkedField",
      "name": "problemSolveInfo",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TaskProblemSolveInfoDescriptionList_taskProblemSolveInfo"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "TaskSpecialAnswer",
          "kind": "LinkedField",
          "name": "specialAnswers",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "rank",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "answer",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "percentage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Task",
  "abstractKey": null
};
})();

(node as any).hash = "64f85b6ebbb8ee30f188a6f7ea440839";

export default node;
